<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :class="className"
    :style="style"
    :viewBox="viewBox"
    role="presentation"
  >
    <component :is="icon" />
  </svg >
</template >

<script>
  import { defineComponent } from "vue";
  import box from "icons/box";
  import questionCircle from "icons/question-circle";
  import contract from "icons/contract";
  import knowledge from "icons/knowledge";
  import contact from "icons/contact";
  import search from "icons/search";
  import listUl from "icons/list-ul";
  import grid from "icons/grid";
  import folder from "icons/folder";
  import tagsFill from "icons/tags-fill";
  import threeDots from "icons/three-dots";
  import check from "icons/check";
  import trash from "icons/trash";
  import fileEarmarkRichtext from "icons/file-earmark-richtext";
  import fileEarmarkCheck from "icons/file-earmark-check";
  import fileEarmarkText from "icons/file-earmark-text";
  import boxArrowUpRight from "icons/box-arrow-up-right";
  import plus from "icons/plus";
  import dash from "icons/dash";
  import x from "icons/x";
  import list from "icons/list";
  import envelope from "icons/envelope";
  import envelope_open from "icons/envelope-open";
  import pin_angle from "icons/pin-angle";
  import card_checklist from "icons/card-checklist";
  import file_earmark_play from "icons/file-earmark-play";
  import file_earmark_slides from "icons/file-earmark-slides";
  import file_earmark_text from "icons/file-earmark-text";
  import file_earmark_music from "icons/file-earmark-music";
  import pencil_square from "icons/pencil-square";
  import clipboard_check from "icons/clipboard-check";
  import clipboard_data from "icons/clipboard-data";
  import download from "icons/download";
  import box_arrow_up_right from "icons/box-arrow-up-right";
  import circle from "icons/circle";
  import xLg from "icons/x-lg";
  import plus_lg from "icons/plus-lg";
  import dash_lg from "icons/dash-lg";
  import play from "icons/play";
  import pause from "icons/pause";
  import arrow_clockwise from "icons/arrow-clockwise";
  import volume_mute from "icons/volume-mute";
  import volume_off from "icons/volume-off";
  import volume_down from "icons/volume-down";
  import volume_up from "icons/volume-up";
  import chevronDoubleRight from "icons/chevron-double-right";
  import chevronDoubleLeft from "icons/chevron-double-left";
  import chevronUp from "icons/chevron-up";
  import chevronDown from "icons/chevron-down";
  import lightbulb from "icons/lightbulb";
  import book from "icons/book";
  import skip_forward from "icons/skip-forward";
  import skip_backward from "icons/skip-backward";
  import funnel from "icons/funnel";
  import funnel_fill from "icons/funnel-fill";
  import arrows_horizontal from "icons/arrows-horizontal";
  import arrows_news from "icons/arrows-news";
  import cursor from "icons/cursor";
  import hand_index from "icons/hand-index";
  import fast_forward from "icons/fast-forward";
  import rewind from "icons/rewind";
  import exclamation_circle from "icons/exclamation-circle";
  import boxes from "icons/boxes";

  const _icons = {
    box,
    questionCircle,
    contract,
    knowledge,
    contact,
    search,
    listUl,
    grid,
    folder,
    tagsFill,
    threeDots,
    check,
    trash,
    fileEarmarkRichtext,
    fileEarmarkCheck,
    fileEarmarkText,
    boxArrowUpRight,
    plus,
    dash,
    x,
    list,
    envelope,
    envelope_open,
    pin_angle,
    card_checklist,
    file_earmark_play,
    file_earmark_slides,
    file_earmark_text,
    file_earmark_music,
    pencil_square,
    clipboard_check,
    clipboard_data,
    download,
    box_arrow_up_right,
    circle,
    xLg,
    plus_lg,
    dash_lg,
    play,
    pause,
    arrow_clockwise,
    volume_mute,
    volume_off, 
    volume_down,
    volume_up,
    chevronDoubleRight,
    chevronDoubleLeft,
    chevronUp,
    chevronDown,
    lightbulb,
    book,
    skip_forward,
    skip_backward,
    funnel,
    funnel_fill,
    arrows_horizontal,
    arrows_news,
    cursor,
    hand_index,
    fast_forward,
    rewind,
    exclamation_circle,
    boxes,
  };

  export default defineComponent({
    computed: {
      icon() {
        return _icons[this.name];
      },
      className() {
        let classnames = ['svgicon bi', `bi-${this.name}`];
        if (this.class) {
          classnames.push(this.class);
        }
        return classnames.join(' ');
      }
    },
    props: {
      viewBox: {
        type: String,
        default: '0 0 16 16'
      },
      class: {
        type: String,
        default: 'svgicon'
      },
      style: {
        type: Object,
        default: null
      },
      name: {
        type: String,
        default: 'box'
      }
    }
  });
</script>
<style>
  .svgicon {
    width: 16px;
    height: 16px;
    fill: currentColor;
    display: inline-block;
  }
  .svgicon-fill-none {
    fill: none;
  }
</style>
